import React from "react";
import { Link } from "react-router-dom";

export default function Dates({ sale }) {
  const registrationOpen = Boolean(sale) && !sale.consignment_closed;

  return (
    <div className="dates">
      <div className="title">Important Dates</div>
      <div className="subtitle has-text-centered mb-4">
        <strong>Waitsfield Ski &amp; Skate Sale 2026</strong>
        <br />
        11/14 • 9:00am–4:00pm
      </div>
      <p className="has-text-weight-bold is-uppercase mb-3">
        Important consignment dates:
      </p>
      <ul className="has-text-left" aria-label="Important consignment dates">
        {registrationOpen && (
          <li>
            <strong>NOW - Consignment Registration is OPEN</strong>
            <br />
            <Link to="/dashboard/inventory/add">CLICK HERE</Link> to register
            your items for the Sale!
          </li>
        )}
        <li>
          <strong>11/09 at 11pm - Consignment Registration closes.</strong>
          <br />
          If your item is not registered it cannot be sold.
        </li>
        <li>
          <strong>11/11 Tag Pickup Begins at Waitsfield Elementary School.</strong>
          <br />
          Please find the envelope with your last name to pick up your printed
          tags for consignment items. Tags will be available in front of the
          school starting Wednesday 11/11 through Friday 11/13, including at
          drop off Friday night.
        </li>
        <li>
          <strong>11/13 4pm-7pm Consignment Drop Off at Waitsfield Elementary</strong>
          <br />
          Drop your registered and tagged gear at WES.
        </li>
        <li>
          <strong>11/14 3:45pm-4:15pm Consignment Pickup</strong>
          <br />
          This is the ONLY opportunity to pick up unsold gear. Check the{" "}
          <Link to="/dashboard/inventory">Current Inventory</Link> tab to see
          what has sold and what has not sold. Any unsold items not picked up
          by 4:15pm on Saturday 11/14 will NOT be retrievable.
        </li>
      </ul>
    </div>
  );
}
